export enum DepositanteTypes {
  'LOAD_REQUEST' = '@depositante/LOAD_REQUEST',
  'LOAD_SUCCESS' = '@depositante/LOAD_SUCCESS',
  'LOAD_FAILURE' = '@depositante/LOAD_FAILURE',
  'CLEAN_MOVIENTRADA' = '@depositante/CLEAN_MOVIENTRADA',
}

export interface IDepositante {
  codParc: number;
  inscricaoEstadual: string;
  nome: string;
  cnpjCpf: string;
}

export interface DepositanteState {
  readonly data: IDepositante[];
  readonly loading: boolean;
  readonly error: boolean;
}
